import React from 'react';
import config from '../../../config'
import { compose, withHandlers, withProps, withState } from 'recompose';
import _ from 'lodash';
import { HTMLTrans } from '../../Common/Translations';
import { withModal } from '../../Common/Modal/Modal';

const progresses = ['Active', 'Expired', 'Used'];

export const ProductModal = (props) => {
  const {
    data = [],
    description,
    startProject,
    startProjectWithoutProductFamily,
  } = props;

  return (
    <div className="text-left">
      <p className="title font-title">
        {
          Object.keys(data).length > 0
            ? <HTMLTrans
              id="account.voucher_viewcomp_modal_select_products">Select Products</HTMLTrans>
            : <HTMLTrans
              id="account.voucher_viewcomp_modal_voucher_details">Voucher Details</HTMLTrans>
        }
      </p>
      
      {
        Object.keys(data).length > 0
          ? <div>
            <p>
              <HTMLTrans id="account.voucher_viewcomp_description">This voucher is eligible for
                multiple products, please select one to proceed.</HTMLTrans>
            </p>
            <table className="table table-sm text-center list-item">
              <tbody>
              {
                Object.keys(data).map((index) => (
                  <tr key={index}>
                    <td className="text-left pl-0 align-middle">
                      <span className="font-title">{data[index].description}</span>
                    </td>
                    <td className="text-right pr-0 align-middle">
                      <button
                        type="button"
                        className="btn btn-secondary text-uppercase"
                        onClick={() => startProject(data[index])}>
                        <HTMLTrans id="account.voucher_viewcomp_redeem">Redeem</HTMLTrans>
                      </button>
                    </td>
                  </tr>
                ))
              }
              </tbody>
            </table>
          </div>
          : <div>
            <hr className="my-3"/>
            <p>{description}</p>
            <div className="d-flex justify-content-center align-middle">
              <button
                type="button"
                className="btn btn-secondary text-uppercase"
                onClick={startProjectWithoutProductFamily}>
                <HTMLTrans id="account.voucher_viewcomp_allproducts">Redeem</HTMLTrans>
              </button>
            </div>
          </div>
      }
    </div>
  );
};

export const enhance = compose(
  withState('open', 'showModal', false),
  withState('data', 'setData', []),
  withProps({
    size: 'lg',
    modalBody: ProductModal,
  }),
  withHandlers({
    createProject: props => () => {
      const {
        getApplicableProducts,
        showModal,
        setData,
      } = props;

      getApplicableProducts()
        .done((response) => {
          showModal(true);
          setData(response.data);
        });
    },
    startProject: ({ handleCategoryOrEditorRedirect, showModal }) => async (item) => {
      await showModal(false);
      handleCategoryOrEditorRedirect(`/${item.friendly_url}`, item.attributes, 'my_voucher', item.is_photobook, item.is_epic_photobook);
    },
    startProjectWithoutProductFamily: ({ handleCategoryOrEditorRedirect, showModal }) => async () => {
      await showModal(false);
      handleCategoryOrEditorRedirect('/products');
    },
  }),
  withModal,
);

const goToApp = () => {
  window.location.href = config.voucherWalletOneLink
}

const ApplyVoucherButton = enhance(({ createProject,innerRef }) => (
  <button 
    type="button" 
    className='btn btn-secondary' 
    ref={innerRef}
    onClick={createProject}>
    <HTMLTrans id="account.voucher_viewcomp_startproject">Start Project</HTMLTrans>
  </button>
));

const GoToAppButton = () => (
  <button 
    type="button" 
    className='btn btn-secondary' 
    onClick={goToApp}>
    <HTMLTrans id="account.voucher_viewcomp_go_to_app">Go To App</HTMLTrans>
  </button>
);

export const VoucherCard = props => (
  props.voucherCode && (
    <div className='voucher-card mt-4' ref={props.innerRef}>
      <div className=' my-5'>
        <div className='mx-5 mb-4'>
          <div className='row no-gutters'>
            <div>
              <div className='my-1'>
                <span className='ProximaNova-Bold title'>
                  {props.name}
                </span>
              </div>
            </div>
            <div className='my-1 col-md-2 ml-auto'>
              <div
                className="voucher-chip"
                hidden={(props.promotionPlatforms && props.promotionPlatforms.length == 1 && props.promotionPlatforms[0] == 'mobile') ? false : true}
                >
                <HTMLTrans id="account.voucher_viewcomp_voucher_chip">App Voucher</HTMLTrans>
              </div>
            </div>
          </div>
          <br />
          <p className='voucher-detail mb-0'>
            <span dangerouslySetInnerHTML={{ __html: props.description }} />
          </p>
          <div className='row'>
            <VoucherLineItem
              title={props.isGiftCard ? <HTMLTrans id="account.giftcard_viewcomp_lineitem1">Store Credit:</HTMLTrans> : <HTMLTrans id="account.voucher_viewcomp_lineitem1">Purchased price:</HTMLTrans>}
              detail={props.price}
              containerClass='col-6'
              textColor='primary'
            />
            <VoucherLineItem
              title={<HTMLTrans id="account.voucher_viewcomp_lineitem2">Prepaid Type:</HTMLTrans>}
              detail={props.type}
              containerClass='col-6'
              textColor='primary'
            />
            <VoucherLineItem
              title={<HTMLTrans id="account.voucher_viewcomp_lineitem3">Voucher Status:</HTMLTrans>}
              detail={props.status}
              containerClass='col-6'
              textColor='primary'
            />
          </div>
        </div>
        <div className='voucher-dash'/>
        <div className='mx-5'>
          <div className='row'>
            <VoucherLineItem
              title={<HTMLTrans id="account.voucher_viewcomp_lineitem4">Expiry date:</HTMLTrans>}
              detail={props.expiryDate}
              containerClass='col-12 voucher-code--mobile'
              textColor='secondary'
            />
            <VoucherLineItem
              title={<HTMLTrans id="account.voucher_viewcomp_lineitem5">Voucher code:</HTMLTrans>}
              detail={props.voucherCode}
              containerClass='col-12 voucher-code--mobile'
              textColor='secondary'
            />
            <div className='col-12 col-lg-4 mt-4 voucher-code--mobile'>
              {
                props.promotionPlatforms && props.promotionPlatforms.length == 1 && props.promotionPlatforms[0] == 'mobile'
                ? <div className='col-auto d-flex flex-column align-items-center pb-3'>
                    <GoToAppButton />
                  </div>
                : !props.currentStatus
                  || <div className='col-auto d-flex flex-column align-items-center pb-3'>
                    <ApplyVoucherButton
                      innerRef={props.buttonRef}
                      description={props.description}
                      getApplicableProducts={props.getApplicableProducts}
                      handleCategoryOrEditorRedirect={props.handleCategoryOrEditorRedirect}/>
                  </div>
              }
            </div>
            {(props.promotionPlatforms && _.includes(props.promotionPlatforms, 'web') && props.displayOptions.expiry_button_enabled) &&
              <div className='row mt-2'>
                <div className="col voucher-code--mobile">
                  <a href="#" className="text-secondary" onClick={props.onClick}>
                    <u><HTMLTrans id="account.voucher_viewcomp_button_extend">Extend Expiry Date</HTMLTrans></u>
                  </a>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
);

const VoucherLineItem = props => (
  <div className={`col-lg-4 mt-4 ${props.containerClass}`}>
    <div className='voucher-detail'>
      {props.title}
    </div>
    <div className={`ProximaNova-Bold text-${props.textColor} text-uppercase voucher__code`}>
      {props.detail}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/Account/Voucher/ViewComp.js